function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Vue from 'vue';
import RatioMixin from '../../mixins/ratio.js';
import ListenersMixin from '../../mixins/listeners.js';
export default Vue.extend({
  name: 'QVideo',
  mixins: [RatioMixin, ListenersMixin],
  props: {
    src: {
      type: String,
      required: true
    },
    title: String,
    fetchpriority: {
      type: String,
      "default": 'auto'
    },
    loading: {
      type: String,
      "default": 'eager'
    },
    referrerpolicy: {
      type: String,
      "default": 'strict-origin-when-cross-origin'
    }
  },
  computed: {
    iframeData: function iframeData() {
      return {
        attrs: {
          src: this.src,
          frameborder: '0',
          title: this.title,
          allowfullscreen: true,
          fetchpriority: this.fetchpriority,
          loading: this.loading,
          referrerpolicy: this.referrerpolicy
        }
      };
    },
    classes: function classes() {
      return 'q-video' + (this.ratio !== void 0 ? ' q-video--responsive' : '');
    }
  },
  render: function render(h) {
    return h('div', {
      "class": this.classes,
      style: this.ratioStyle,
      on: _objectSpread({}, this.qListeners)
    }, [h('iframe', this.iframeData)]);
  }
});